var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (config, playinline, tiles, undefined) {
jade_mixins["video-stream"] = jade_interp = function(videoUrl, playsinline, controls, klass, poster){
var block = (this && this.block), attributes = (this && this.attributes) || {};
playinline = playinline || true
controls = controls || true
klass = klass || 'video vjs-fluid'
var cloudinaryVideoFolderUrl = config.CLOUDINARY_CDN_URL+config.CLOUDINARY_VIDEO_FOLDER
var streamUrl = ''
if ( videoUrl && videoUrl.indexOf(cloudinaryVideoFolderUrl) > -1)
{
streamUrl = videoUrl.replace(cloudinaryVideoFolderUrl, cloudinaryVideoFolderUrl+'sp_full_hd/')
streamUrl = streamUrl.replace('.mp4', '.m3u8')
}
buf.push("<video" + (jade.attr("webkit-playsinline", playsinline, true, false)) + (jade.attr("controls", controls, true, false)) + " preload=\"auto\"" + (jade.attr("dir", config.direction, true, false)) + (jade.attr("poster", poster, true, false)) + (jade.cls(['video-js',klass], [null,true])) + "><source" + (jade.attr("src", videoUrl, true, false)) + "/>");
if ( streamUrl)
{
buf.push("<source" + (jade.attr("src", streamUrl, true, false)) + "/>");
}
buf.push("</video>");
};
jade_mixins["image"] = jade_interp = function(imageUrl, klass){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<img" + (jade.attr("src", imageUrl, true, false)) + (jade.cls([klass], [true])) + "/>");
};
jade_mixins["multi-content"] = jade_interp = function(prop, obj){
var block = (this && this.block), attributes = (this && this.attributes) || {};
obj = obj || locals;
switch (obj[prop + "Type"]){
case "image":
buf.push("<div" + (jade.attr("data-content", obj.image, true, false)) + " class=\"multi-content-wrapper multi-content-wrapper-image block-md block-lt\"><div class=\"block-sm multi-content-media\">");
jade_mixins["image"](obj[prop], 'multi-content multi-content-image');
buf.push("</div></div>");
  break;
case "video":
buf.push("<div class=\"multi-content-wrapper multi-content-wrapper-video block-md block-lt\"><div class=\"block-sm multi-content-media\">");
jade_mixins["video-stream"](obj[prop], true, true,"multi-content multi-content-video block-dk");
buf.push("</div></div>");
  break;
case "audio":
buf.push("<div class=\"multi-content-wrapper multi-content-wrapper-audio block-md block-lt\"><div class=\"block-sm multi-content-media\"><audio" + (jade.attr("src", obj[prop], true, false)) + " playsinline=\"playsinline\" preload=\"auto\" controls=\"controls\"" + (jade.attr("dir", config.direction, true, false)) + " class=\"multi-content multi-content-audio block-dk\"></audio></div></div>");
  break;
case "iframe":
buf.push("<div class=\"multi-content-wrapper multi-content-wrapper-iframe block-md block-lt\"><div class=\"block-sm multi-content-iframe\">");
var iframe = obj[prop].match(/<iframe[^<]*<\/iframe>/)
if ( iframe)
{
buf.push(null == (jade_interp = iframe[0].replace(/ (width|height)=["'\d\w]+/g, "")) ? "" : jade_interp);
}
buf.push("</div></div>");
  break;
default:
buf.push("<span class=\"multi-content multi-content-text\">" + (null == (jade_interp = obj[prop]) ? "" : jade_interp) + "</span>");
  break;
}
};
// iterate tiles
;(function(){
  var $$obj = tiles;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var tile = $$obj[$index];

buf.push("<div" + (jade.attr("data-index", tile.index, true, false)) + (jade.cls(['tile',"tile-" + ((tiles.length / 2)) + ""], [null,true])) + "><div class=\"tile-content\"><div class=\"btn btn-solid tile-front\"><div class=\"content text-xl\">?</div></div><div" + (jade.cls(['btn','btn-solid','tile-back',tile.klass], [null,null,null,true])) + ">");
jade_mixins["multi-content"]("content", tile);
buf.push("</div></div></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var tile = $$obj[$index];

buf.push("<div" + (jade.attr("data-index", tile.index, true, false)) + (jade.cls(['tile',"tile-" + ((tiles.length / 2)) + ""], [null,true])) + "><div class=\"tile-content\"><div class=\"btn btn-solid tile-front\"><div class=\"content text-xl\">?</div></div><div" + (jade.cls(['btn','btn-solid','tile-back',tile.klass], [null,null,null,true])) + ">");
jade_mixins["multi-content"]("content", tile);
buf.push("</div></div></div>");
    }

  }
}).call(this);
}.call(this,"config" in locals_for_with?locals_for_with.config:typeof config!=="undefined"?config:undefined,"playinline" in locals_for_with?locals_for_with.playinline:typeof playinline!=="undefined"?playinline:undefined,"tiles" in locals_for_with?locals_for_with.tiles:typeof tiles!=="undefined"?tiles:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}